"use strict";
export { Icon, IconPropsProvider } from './icon.js';
export { createIcon } from './create-icon.js';
